import { render } from "./MainFooter.vue?vue&type=template&id=a8bd49a4"
const script = {}

import "./MainFooter.vue?vue&type=style&index=0&id=a8bd49a4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__